import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Accordion, Col, Dropdown, Row, Spinner } from "react-bootstrap";
import {
  getNotification,
  deleteNotification,
} from "app/services/memberService";
import queryString from "app/services/queryStringService";
import _ from "lodash";
import {
  MdEdit,
  MdDelete,
  MdVpnKey,
  MdSearch,
  MdRefresh,
  MdSettings,
} from "react-icons/md";
import { Helmet } from "react-helmet";

import AddNotification from "./AddNotification";
import EditNotification from "./EditNotification";
import "./Notification.css";
import config from "config.json";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import usePagePermission from "app/hooks/usePagePermission";
import { AiFillEdit } from "react-icons/ai";
import Swal from "sweetalert2";
import HandyScroll from "app/common/Scroll";
const { dateTimeFormat } = config;
const NotificationSettings = () => {
  const { canAdd, canEdit, canDelete } = usePagePermission();

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(0);
  const [affiliateId, setAffiliateId] = useState("");
  const [company, setCompany] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [status, setStatus] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [group, setGroup] = useState("");

  const dateFormatter = (cell, row) => {
    return moment(cell).format(dateTimeFormat);
  };

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "affiliateId":
        setAffiliateId(value);
        break;
      case "company":
        setCompany(value);
        break;
      case "firstName":
        setFirstName(value);
        break;
      case "lastName":
        setLastName(value);
        break;
      case "emailId":
        setEmailId(value);
        break;
      case "status":
        setStatus(value);
        break;
      case "city":
        setCity(value);
        break;
      case "state":
        setState(value);
        break;
      case "country":
        setCountry(value);
        break;
      case "group":
        setGroup(value);
        break;
      default:
        break;
    }
  };

  const refreshFilter = async (e) => {
    setAffiliateId("");
    setCompany("");
    setFirstName("");
    setLastName("");
    setEmailId("");
    setStatus("");
    setCity("");
    setState("");
    setCountry("");
    setGroup("");

    setTimeout(async () => {
      await loadNotification();
    }, 10);
  };

  const editHandler = (id) => {
    setEditId(id);
  };

  const deleteNotificationHandler = async (id) => {
    Swal.fire({
      title: `Are you sure you want to Delete this Details?`,
      icon: "warning",

      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.value) {
        const response = await deleteNotification(id);
        console.log(response);
        if (response.status === "Success") {
          NotificationManager.success(response.data.message);
        } else {
          NotificationManager.error(response.data.message);
        }
        await loadNotification();
      } else {
        Swal.fire({
          title: "Cancelled!",
          text: "Permission denied.",

          icon: "error",
          timer: 1500,
        });
      }
    });
  };

  const actionFormatter = (cell, row) => {
    return (
      <>
        <Row className="ml-4 d-flex justify-content-center">
          <Col xs={1} lg={3}>
            {canEdit ? (
              <div style={{ cursor: "pointer" }}>
                <AiFillEdit
                  onClick={() => editHandler(row.id)}
                  data-bs-toggle="modal"
                  data-bs-target="#EditNotificationModal"
                  size="1.5em"
                  color="black"
                ></AiFillEdit>
              </div>
            ) : (
              <AiFillEdit
                // onClick={() => editHandler(row.id)}
                // data-bs-toggle="modal"
                // data-bs-target="#EditNotificationModal"
                size="1.5em"
                color="gray"
              ></AiFillEdit>
            )}
          </Col>

          <Col xs={1} lg={3}>
            {canDelete ? (
              <div style={{ cursor: "pointer" }}>
                <MdDelete
                  onClick={() => deleteNotificationHandler(row.id)}
                  size="1.5em"
                  color="red"
                  variant="danger"
                  className="mx-4"
                />
              </div>
            ) : (
              <MdDelete
                // onClick={() => deleteNotificationHandler(row.id)}
                size="1.5em"
                color="FF7171"
                variant="danger"
                className="mx-4"
              />
            )}
          </Col>
        </Row>
      </>
    );
  };

  const statusFormatter = (cell, row) => {
    if (row.status === true) {
      return <span style={{ color: "green" }}> Active </span>;
    } else {
      return <span style={{ color: "red" }}> Inactive</span>;
    }
  };

  const columns = [
    {
      dataField: "memId",
      text: "Id",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
    },
    {
      dataField: "notificationSubject",
      text: "Notification Subject",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "notificationDescription",
      text: "Notification Description",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
    },
    {
      dataField: "notificationDate",
      text: "Notification Date",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: dateFormatter,
    },

    {
      dataField: "status",
      text: "Activation Status",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: statusFormatter,
    },
    {
      dataField: "id",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadNotification = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });

    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await getNotification(query);

    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };

  useEffect(() => {
    loadNotification();
  }, [page, sizePerPage]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    await loadNotification();
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );
  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      {/* <div className="text-right bg-transparent"> */}
      {/* <Link
          className="btn btn-primary btn-md float-right"
          to="/admin/add-notifiication"
        >
        </Link> */}
      <button
        type="button"
        className="btn btn-primary float-end"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
      >
        <i className="i-Add-User text-white mr-2"></i> Add New Notification
      </button>
      <Helmet>
        <title>Notification Settings</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Notification Settings" }]}
      ></Breadcrumb>

      <div>
        <HandyScroll>
          <div
            class="spacious-container"
            data-handy-scroll
            style={{ overflow: "auto" }}
          >
            <BootstrapTable
              hover
              remote
              keyField="uniqueIdentity"
              data={data}
              columns={
                canEdit ? columns : columns.filter((x) => x.text !== "Action")
              }
              pagination={paginationFactory(paginationOptions)}
              onTableChange={handleTableChange}
              noDataIndication={() => <NoDataIndication />}
              headerClasses="bg-primary text-white"
              bodyClasses="react-bootstrap-table-next-min-height"
              rowStyle={rowStyle}
            />
          </div>
        </HandyScroll>
      </div>
      <AddNotification loadNotification={loadNotification} />
      <EditNotification id={editId} refreshData={loadNotification} />
    </>
  );
};

export default NotificationSettings;
